const TabOnboardingCompliance = (props) => {
    const {index} = props;

    return ( 
        <div className="max-w-md mx-auto flex">
            
            <Step
                rightColor="transparent"
                centerColor="ep-primary-600"
                leftColor={index === "1" ? "[#9CA3AF]" : "ep-primary-600"}
                text="BVN Verification"
            />
            
            <div className="flex-grow">
                <div className="h-10 flex">
                    <div className={"w-full h-0.5 my-auto " + (index === "1" ? "bg-[#9CA3AF]":"bg-ep-primary-600")}></div>
                </div>
            </div>
            
            <Step
                rightColor={index === "2" ? "ep-primary-600" : "[#9CA3AF]"}
                centerColor={index === "2" ? "ep-primary-600" : "[#9CA3AF]"}
                leftColor="transparent"
                text="CAC Upload"
            />

        </div>
    )
}


const Step = (props) => {
    const {rightColor, centerColor, leftColor, text} = props;
    
    return ( 
        <div className="flex-shrink-0 text-center">
            <div className="flex items-center justify-between">
                <div className={`w-full h-0.5 bg-${rightColor}`}></div>
                
                <div className={`w-10 h-10 flex flex-shrink-0 bg-white border-2 border-${centerColor} rounded-full`}>
                    <div className={`w-5 h-5 bg-${centerColor} m-auto rounded-full`}></div>
                </div>
                
                <div className={`w-full h-0.5 bg-${leftColor}`}></div>
            </div>
            <div className={`mt-2 text-${centerColor} font-medium`}>
                {text}
            </div>
        </div>
    )
}


export default TabOnboardingCompliance;